import type { CountryDto } from "../../../../api";
import { Text, Heading } from "../../../../components/common/typography";
import { IconMapPin } from "@tabler/icons-react";

interface PartnerAddressProps {
  street: string | null | undefined;
  city: string | null | undefined;
  zip: string | null | undefined;
  country: CountryDto | null | undefined;
}

export function PartnerAddress({ street, city, zip, country }: PartnerAddressProps) {
  const hasAddress = street || city || zip || country;

  return (
    <div className="flex-1 bg-bgWhite rounded-xl p-6 border border-borderDefault">
      <Heading variant="h3" tone="dark" className="mb-4">
        Address
      </Heading>
      {!hasAddress ? (
        <Text variant="body" tone="muted">No address information available</Text>
      ) : (
        <div className="flex flex-col gap-2">
          {street && (
            <div className="flex items-start gap-2">
              <IconMapPin size={20} className="text-textMuted shrink-0" />
              <Text variant="body" tone="dark">{street}</Text>
            </div>
          )}
          {(city || zip) && (
            <div className="flex items-start gap-2 pl-7">
              <Text variant="body" tone="dark">{[city, zip].filter(Boolean).join(", ")}</Text>
            </div>
          )}
          {country && (
            <div className="flex items-start gap-2 pl-7">
              <Text variant="body" tone="dark">{country.name}</Text>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
